import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 8",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill="#193446" fill-rule="evenodd" d="M12.664 4.346h1.482v-.963h-1.482V1.16H1.331v5.407h11.333V4.346zM.331 6.575V1.148a.994.994 0 01.993-.987h11.353a.987.987 0 01.987.987v1.235h1.482v2.963h-1.482V6.58a.988.988 0 01-.987.987H1.318a.994.994 0 01-.987-.993z" clip-rule="evenodd"/>' }
  })
);